import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/services/http/http.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { IData } from 'src/app/models/data.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DashboardService extends HttpService {

  private mockData: IData[] = [
    {
      CASES: 10,
      QUEUE_NM: "Blue(RD)Non-Lobby"
    },
    {
      CASES: 20,
      QUEUE_NM: "Blue(Renewals)Non-Lobby"
    },
    {
      CASES: 15,
      QUEUE_NM: "Green(Intake)Non-Lobby"
    },
    {
      CASES: 62,
      QUEUE_NM: "Orange(Changes)Non-Lobby"
    }
  ];

  constructor(http: HttpClient, private _router: Router) { 
    super('', http);
  }

  private dataSubject = new BehaviorSubject<IData[]>(this.mockData);
    
  $data = this.dataSubject.asObservable();

  addData(newData: IData) {
      this.mockData.push(newData);
      this.dataSubject.next(this.mockData);
  }

  getFilter() {
    return this.get().map(res => {
      return res['data'];
    }); 
  }
    
}
